<template>
  <div class="layout">
    <div class="sidebar">
      <div class="brand">宇航物流管理平台</div>
      <el-menu :default-active="$route.path" router class="menu" background-color="#0b1220" text-color="#cbd5e1" active-text-color="#60a5fa">
        <template v-for="m in menus">
          <el-submenu v-if="m.children && m.children.length" :key="m.id" :index="m.path || m.id">
            <template slot="title">
              <span>{{ m.name }}</span>
            </template>
            <el-menu-item v-for="c in m.children" :key="c.id" :index="c.path">
              {{ c.name }}
            </el-menu-item>
          </el-submenu>
          <el-menu-item v-else :key="m.id" :index="m.path">
            {{ m.name }}
          </el-menu-item>
        </template>
      </el-menu>
    </div>

    <div class="main">
      <div class="topbar">
        <div class="title">{{ $route.meta.title || '' }}</div>
        <div class="actions">
          <el-button type="text" @click="logout">退出登录</el-button>
        </div>
      </div>
      <div class="content">
        <div class="page-container">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../utils/request'
import { clearAuth, getMenus, setMenus } from '../utils/auth'

export default {
  name: 'Layout',
  data() {
    return {
      menus: getMenus()
    }
  },
  async created() {
    if (!this.menus.length) {
      try {
        const menus = await request.get('/admin/api/auth/menus')
        setMenus(menus)
        this.menus = menus
      } catch (e) {
        // ignore
      }
    }
  },
  methods: {
    logout() {
      clearAuth()
      this.$router.replace('/login')
    }
  }
}
</script>

<style>
.layout {
  height: 100%;
  background: #f1f5f9;
}

/* 左侧菜单固定 */
.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 240px;
  background: #0b1220;
  color: #e2e8f0;
  display: flex;
  flex-direction: column;
}

.brand {
  height: 56px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  font-weight: 800;
  letter-spacing: 1px;
  flex: 0 0 auto;
}

.menu {
  border-right: none;
  flex: 1;
  overflow: auto;
}

/* 右侧内容自适应 */
.main {
  margin-left: 240px;
  height: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.topbar {
  height: 56px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-bottom: 1px solid #e5e7eb;
  flex: 0 0 auto;
}

.title {
  font-weight: 700;
  color: #0f172a;
}

/* 只让右侧内容区域滚动，避免 body 滚动导致高度链路断裂 */
.content {
  flex: 1;
  min-height: 0;
  padding: 16px;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.page-container {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* 注意：这里必须是全局样式，否则 router-view 里的页面根节点吃不到 flex:1 */
.page-container > * {
  flex: 1;
  min-height: 0;
}
</style>

